import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana87Div2M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1461_5342)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M584.604 457.246L597.826 508.246L503.383 517.69L499.605 464.802L584.604 457.246Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M605.384 536.577L597.828 508.244L535.496 515.8L541.162 589.466C556.273 585.058 588.762 574.732 597.828 568.688C606.895 562.644 606.643 544.762 605.384 536.577Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M526.059 592.82L541.156 589.465L535.49 515.799L439.157 523.354L522.651 592.005C523.601 592.786 524.858 593.087 526.059 592.82Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M384.382 476.142L439.159 523.364L503.381 517.697L499.603 464.809L384.382 476.142Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1461_5342" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1461_5342" transform="matrix(0.0025909 0 0 0.00343484 -6.63116 -2.58269)"/>
    </pattern>
    <image id="image0_1461_5342" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};